import { render } from "./ProgramsTable.vue?vue&type=template&id=378d611d&scoped=true"
import script from "./ProgramsTable.vue?vue&type=script&lang=js"
export * from "./ProgramsTable.vue?vue&type=script&lang=js"

import "./ProgramsTable.vue?vue&type=style&index=0&id=378d611d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-378d611d"]])

export default __exports__